import React from "react";
import {
  CsplTable as Table,
  DatePicker,
  FieldDropSide,
  Select,
  Link,
  SearchableList,
  MultiSelectDropdown,
} from "../../../components";
import { getTwoDecimalPlaces } from "../../../utils";
const columns = [
  {
    label: "Particulars",
    className: "table-width-40",
    columnName: "particulars",
  },
  {
    label: "Dec-22",
    className: "table-width-30",
    columnName: "col1",
  },
  {
    label: "Dec-21",
    className: "table-width-30",
    columnName: "col2",
  },
];
const data = [
  {
    particulars:
      "Change in the value of investments Due to appreciation/ (Depreciation)",
    col1: 340123,
    col2: 102123,
  },
  {
    particulars: "Dividend Income",
    col1: 340123,
    col2: 102123,
  },
  {
    particulars: "Interest Income",
    col1: 340123,
    col2: 102123,
  },
];
const contributionsData = [
  {
    particulars: "Contributions",
    col1: 340123,
    col2: 102123,
  },
  {
    particulars: "Rollovers",
    col1: 340123,
    col2: 102123,
  },
];
const data2 = [
  {
    particulars: "Withdrawal/ Distributions",
    col1: 340123,
    col2: 102123,
  },
  {
    particulars: "Administrative expense including fees",
    col1: 340123,
    col2: 102123,
  },
];
const data3 = [
  {
    particulars: "Net increase in Net assets",
    col1: 340123,
    col2: 102123,
  },
  {
    particulars: "Transfers for the period",
    col1: 340123,
    col2: 102123,
  },
  {
    particulars: "Units change for the period",
    col1: 340123,
    col2: 102123,
  },
];

const totalAdditions = {
  particulars: "Total Additions",
  col1: 340123,
  col2: 102123,
};
export const StatementChangesinAssetsTable = (props) => {
  return (
    <Table>
      <Table.Thead>
        <Table.Tr>
          {columns.map((e, i) => (
            <Table.Th className={e.className}>{e.label}</Table.Th>
          ))}
        </Table.Tr>
      </Table.Thead>
      <Table.Tbody>
        <Table.Tr>
          <Table.Th className="table-sub-header">
            Additions to net Assets
          </Table.Th>
        </Table.Tr>
        <Table.Tr>
          <Table.Th className="table-sub-header">Investment Income</Table.Th>
        </Table.Tr>
        {data.map((e, i) => (
          <Table.Tr>
            {columns.map((f, j) =>
              f.columnName === "particulars" ? (
                <Table.Td className={f.className}>{e[f.columnName]}</Table.Td>
              ) : (
                <Table.Td className={f.className}>
                  ${getTwoDecimalPlaces(e[f.columnName])}
                </Table.Td>
              )
            )}
          </Table.Tr>
        ))}
        {contributionsData.map((e, i) => (
          <Table.Tr>
            {columns.map((f, j) =>
              f.columnName === "particulars" ? (
                <Table.Td className={`${f.className} table-total-value`}>
                  {e[f.columnName]}
                </Table.Td>
              ) : (
                <Table.Td className={`${f.className} table-total-value`}>
                  ${getTwoDecimalPlaces(e[f.columnName])}
                </Table.Td>
              )
            )}
          </Table.Tr>
        ))}
        <Table.Tr>
          {columns.map((f, j) =>
            f.columnName === "particulars" ? (
              <Table.Td className={`${f.className} table-total-value`}>
                {totalAdditions[f.columnName]}
              </Table.Td>
            ) : (
              <Table.Td className={`${f.className} table-total-value`}>
                ${getTwoDecimalPlaces(totalAdditions[f.columnName])}
              </Table.Td>
            )
          )}
        </Table.Tr>
        <Table.Tr>
          <Table.Th className="table-sub-header">
            Deductions from net Assets
          </Table.Th>
        </Table.Tr>
        {data2.map((e, i) => (
          <Table.Tr>
            {columns.map((f, j) =>
              f.columnName === "particulars" ? (
                <Table.Td className={f.className}>{e[f.columnName]}</Table.Td>
              ) : (
                <Table.Td className={f.className}>
                  ${getTwoDecimalPlaces(e[f.columnName])}
                </Table.Td>
              )
            )}
          </Table.Tr>
        ))}
        {data3.map((e, i) => (
          <Table.Tr>
            {columns.map((f, j) =>
              f.columnName === "particulars" ? (
                <Table.Td className={`${f.className} table-total-value`}>
                  {e[f.columnName]}
                </Table.Td>
              ) : (
                <Table.Td className={`${f.className} table-total-value`}>
                  ${getTwoDecimalPlaces(e[f.columnName])}
                </Table.Td>
              )
            )}
          </Table.Tr>
        ))}
      </Table.Tbody>
    </Table>
  );
};
